<script setup lang="ts">
const props = defineProps({
  backUrl: {
    type: String,
  },
});

const hasHistory = computed(() => {
  if (process.server) return false;
  return window.history.state.position > 0;
});

const onNavigateBack = () => {
  if (props.backUrl) {
    navigateTo(props.backUrl, { replace: true });
  } else {
    if (window.history.state.back == null) {
      navigateTo("/");
      return;
    }

    useRouter().back();
  }
};
</script>

<template>
  <div class="h-screen">
    <BaseAppBar class="fixed">
      <template #leading>
        <div class="h-full flex flex-row items-center">
          <slot name="app-bar-leading">
            <ClientOnly>
              <BaseIconButton
                v-if="hasHistory || backUrl"
                :size="40"
                @click="() => onNavigateBack()"
              >
                <icon name="material-symbols:arrow-back" size="20" />
              </BaseIconButton>
            </ClientOnly>
          </slot>
          <div class="ml-2 text-h5">
            <slot name="app-bar-title" />
          </div>
        </div>
      </template>
    </BaseAppBar>
    <div class="pt-[60px] h-full">
      <ClientOnly>
        <div class="p-2 h-full">
          <slot />
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<style scoped></style>
